import { TextSM } from '@reapit/elements'
import { SectionTile } from '@reapitform/dashboard-ui'
import React, { FC } from 'react'

const LoginAndSecuritySection: FC = () => {
  return (
    <SectionTile title="Login & Security" actionTitle="Manage" disableMarginBottom>
      <TextSM hasGreyText>Manage your login, password and two-factor authentication.</TextSM>
    </SectionTile>
  )
}

export default LoginAndSecuritySection
